export const isMobileDevice = (): boolean =>
	/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export const isIPhoneDevice = (): boolean => {
	const { userAgent } = navigator;

	return /iPhone/.test(userAgent) && !/iPad/.test(userAgent);
};
